import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { User } from './models/user';
import { Observable } from 'rxjs';

@Injectable()
export class BaseService {
  private pageName = new Subject<string>();
  public user: User;
  public channels: Observable<any[]>;
  public request: any;
  public component: string;

  constructor(
    protected toastr: ToastrService,
  ) {}

  showSuccess(message: string) {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  showError(message: string) {
    this.toastr.error(message, 'Error!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  pageNameChange$ = this.pageName.asObservable();
  changedComponentName(option: string) {
    this.pageName.next(option);
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/base.service.ts